import { render } from "./DynamicHtmlB.vue?vue&type=template&id=4a52c0d0&ts=true"
import script from "./DynamicHtmlB.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlB.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlB.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a52c0d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a52c0d0', __exports__)) {
    api.reload('4a52c0d0', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlB.vue?vue&type=template&id=4a52c0d0&ts=true", () => {
    api.rerender('4a52c0d0', render)
  })

}


export default __exports__